import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

import { SESSION_STORAGE_KEYS } from 'constants/app';
import { atomWithSessionStorage } from 'service/storage';

export const documentTitleState = atom('');

export const delayButtonState = atomFamily((key) =>
  atomWithSessionStorage(
    `${SESSION_STORAGE_KEYS.DELAY_BUTTON}_${key}`,
    undefined
  )
);

export const sessionTokenState = atomWithSessionStorage(
  SESSION_STORAGE_KEYS.SESSION_TOKEN,
  undefined
);

export const errorState = atom(undefined);
